import React from "react";
import TransporterInformations from "./TransporterInformations";

const TransporterForms = ({ forms, activeTab, setForms }) => {
  if (activeTab === "Informations") {
    return <TransporterInformations forms={forms} setForms={setForms} />;
  }
  return null;
};

export default TransporterForms;
